import { render, staticRenderFns } from "./costDeptDataSingle.vue?vue&type=template&id=c22dd3e4&scoped=true&"
import script from "./costDeptDataSingle.vue?vue&type=script&lang=js&"
export * from "./costDeptDataSingle.vue?vue&type=script&lang=js&"
import style0 from "./costDeptDataSingle.vue?vue&type=style&index=0&id=c22dd3e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c22dd3e4",
  null
  
)

export default component.exports